/** Runtime web configuration — Cognito + API required (no demo fallback). */

const poolId = import.meta.env.VITE_COGNITO_USER_POOL_ID || '';
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID || '';
const apiUrl = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
const region = import.meta.env.VITE_COGNITO_REGION || 'us-east-1';

export interface AppConfig {
  apiUrl: string;
  userPoolId: string;
  clientId: string;
  region: string;
}

export function getAppConfig(): AppConfig {
  return {
    apiUrl,
    userPoolId: poolId,
    clientId,
    region,
  };
}

export function isAppConfigured(): boolean {
  return Boolean(poolId && clientId && apiUrl);
}

export function missingConfigKeys(): string[] {
  const missing: string[] = [];
  if (!poolId) missing.push('VITE_COGNITO_USER_POOL_ID');
  if (!clientId) missing.push('VITE_COGNITO_CLIENT_ID');
  if (!apiUrl) missing.push('VITE_API_URL');
  return missing;
}
